import { render } from "./PermissionRoleForm.vue?vue&type=template&id=560b3c22&scoped=true"
import script from "./PermissionRoleForm.vue?vue&type=script&lang=js"
export * from "./PermissionRoleForm.vue?vue&type=script&lang=js"

import "./PermissionRoleForm.vue?vue&type=style&index=0&id=560b3c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560b3c22"]])

export default __exports__